function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 495 495",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEB99"
    },
    points: "195.086,385 247.5,385 247.5,289.952 173.358,215.811 201.642,187.525 227.5,213.384  227.5,70 247.5,70 247.5,0 100,0 100,315 175.086,315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE477"
    },
    points: "267.5,70 267.5,213.383 293.357,187.525 321.643,215.809 247.5,289.952 247.5,385  299.914,385 319.914,315 395,315 395,0 247.5,0 247.5,70  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2488FF"
    },
    points: "247.5,385 195.086,385 175.086,315 30,315 30,495 247.5,495  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#005ECE"
    },
    points: "319.914,315 299.914,385 247.5,385 247.5,495 465,495 465,315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2488FF"
    },
    points: "293.357,187.525 267.5,213.383 267.5,70 227.5,70 227.5,213.384 201.642,187.525  173.358,215.811 247.5,289.952 321.643,215.809  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.a26401302b8d59be7d3b7e5a43193fa4.svg";
export { ForwardRef as ReactComponent };